import { render, staticRenderFns } from "./ConnectedClient.vue?vue&type=template&id=29741d99&"
import script from "./ConnectedClient.vue?vue&type=script&lang=js&"
export * from "./ConnectedClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports